import React, {Component, useState, useEffect} from "react";
import {
  MDBNavbar, MDBNavbarBrand, MDBNavbarNav, MDBNavItem, MDBNavLink, MDBNavbarToggler, MDBCollapse
} from "./utils/mdb-compat";
import {login, logout} from './utils'
import {useGlobalState, useGlobalMutation} from './utils/container'


const Navbar = () => {
  const [isOpen, setIsOpen] = useState(true); // Default to open so buttons are visible
  const [isSignedIn, setIsSignedIn] = useState(false);
  const [accountId, setAccountId] = useState('');
  const stateCtx = useGlobalState()
  const mutationCtx = useGlobalMutation()

  // Update wallet state periodically and on mount
  useEffect(() => {
    const updateWalletState = () => {
      if (window.walletConnection) {
        const signedIn = window.walletConnection.isSignedIn();
        const accId = window.accountId || '';

        setIsSignedIn(signedIn);
        setAccountId(accId);
      }
    };

    // Update immediately on mount
    updateWalletState();

    // Update frequently to catch wallet changes
    const interval = setInterval(updateWalletState, 60000);

    // Also listen for wallet selector state changes
    if (window.selector) {
      const subscription = window.selector.store.observable.subscribe((state) => {
        updateWalletState();
      });

      return () => {
        clearInterval(interval);
        subscription.unsubscribe();
      };
    }

    return () => clearInterval(interval);
  }, []);

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  }

  return (
    <MDBNavbar color="stylish-color-dark" dark expand="md" className="mb-2" style={{backgroundColor: '#2e3951'}}>
      <MDBNavbarBrand>
        <MDBNavLink className="white-text me-2" to="/" style={{color: 'white'}}>
          <span style={{color: 'white', marginLeft: '10px'}}>sputnik v2 beta</span>
        </MDBNavLink>
      </MDBNavbarBrand>
      <MDBNavbarToggler onClick={toggleCollapse} />
      <MDBCollapse id="navbarCollapse3" isOpen={isOpen} navbar>
        <MDBNavbarNav className="white-text" left>
          <MDBNavItem className="">
            <MDBNavbarBrand style={{color: 'white'}}>{stateCtx.config.contract}</MDBNavbarBrand>
          </MDBNavItem>
        </MDBNavbarNav>
        <MDBNavbarNav right>
          {!isSignedIn ? (
            <MDBNavItem active>
              <MDBNavLink to="#" onClick={login} style={{
                cursor: 'pointer',
                padding: '10px 20px',
                color: 'white',
                fontWeight: 'bold',
                backgroundColor: '#4a90e2',
                borderRadius: '5px',
                margin: '5px'
              }}>
                Sign In
              </MDBNavLink>
            </MDBNavItem>
          ) : (
            <>
              <MDBNavItem active>
                <MDBNavbarBrand style={{color: 'white', marginRight: '10px'}}>{accountId}</MDBNavbarBrand>
              </MDBNavItem>
              <MDBNavItem active>
                <MDBNavLink to="#" onClick={logout} style={{
                  cursor: 'pointer',
                  color: 'white',
                  padding: '10px 15px'
                }}>
                  Sign Out
                </MDBNavLink>
              </MDBNavItem>
            </>
          )}
        </MDBNavbarNav>
      </MDBCollapse>
    </MDBNavbar>
  );

}

export default Navbar;
